<template>
  <v-card>
    <v-card-text class="d-flex flex-row py-6 py-md-8 pl-6 pl-md-8 pr-6 pr-md-0">
      <div class="ma-0 ma-md-2 flex-grow-1 d-flex flex-column">
        <div class="cookies-consent__basic__title text-h1">
          {{ $t('cookiesConsent.basic.title') }}
        </div>
        <div class="cookies-consent__basic__perex mt-8">
          <i18n path="cookiesConsent.basic.perex" tag="span">
            <template #technical>
              <strong>{{ $t('cookiesConsent.basic.technical') }}</strong>
            </template>
            <template #analytical>
              <strong>{{ $t('cookiesConsent.basic.analytical') }}</strong>
            </template>
            <template #marketing>
              <strong>{{ $t('cookiesConsent.basic.marketing') }}</strong>
            </template>
          </i18n>
        </div>
        <v-row class="cookies-consent__basic__actions d-flex flex-row mt-6" no-gutters>
          <v-col cols="12" md="4" class="pr-md-1 pb-2 pb-md-0">
            <v-btn color="primary" block @click="acceptAllCookies">
              {{ $t('agree') }}
            </v-btn>
          </v-col>
          <v-col cols="6" md="4" class="pr-1 pl-md-1">
            <v-btn color="tetrary" block @click="denyAllCookies">
              {{ $t('disagree') }}
            </v-btn>
          </v-col>
          <v-col cols="6" md="4" class="pl-1">
            <v-btn color="tetrary" block @click="showCookiesSettings = true">
              {{ $t('cookiesConsent.basic.customize') }}
            </v-btn>
          </v-col>
        </v-row>
      </div>
      <div class="flex-shrink-1 flex-grow-0 mt-n6 ml-n10 d-none d-md-block">
        <v-img :src="$asset('img/cookies-doctor.png')" contain max-width="254px" />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import cookiesConsent from '@/mixins/cookiesConsent';

export default {
  name: 'CookiesConsentBasic',
  mixins: [cookiesConsent]
};
</script>

<style scoped lang="scss">
.cookies-consent {
  &__basic {
    &__title {
      position: relative;

      @media #{map-get($display-breakpoints, 'md-and-up')} {
        &:after {
          position: absolute;
          content: '';
          background: url('@/assets/img/banner-title-underlines.svg');
          height: 19px;
          width: 172px;
          top: 21px;
          left: 76px;
        }
      }
    }

    &__perex {
      max-width: 349px;
      width: 100%;
    }
  }
}
</style>
